/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import type {
    BodyCreatePrivateShareTestPrivateSharePostDTO,
    CollectionDTO,
    CollectionTypeDTO,
    DeleteFilesRespDTO,
    DeleteRequestTestEraseStoreSubParams,
    DeleteRequestTestRemoveNonDefaultGrants200,
    DeleteRequestTestThrowawayUserTemplateParams,
    DeleteTemplateRespDTO,
    DummyPoliceJwtRespDTO,
    EmailConsentIDDTO,
    GetRequestTestCreateDummySignedJwtParams,
    GetRequestTestEmailConsentIdParams,
    GetRequestTestLoginIdentifierParams,
    GetRequestTestMemoryCollectionsByCollectionUuidParams,
    HTTPValidationErrorDTO,
    LocaleRespDTO,
    LoginIdentifierRespDTO,
    MessageResponseDTO,
    PostRequestTestAddGrantParams,
    PostRequestTestClientParams200,
    PostRequestTestClientParamsParams,
    PostRequestTestDeleteStripeDataParams,
    PostRequestTestDeleteUserWithoutTelenorIdComsParams,
    PostRequestTestDigitalLegacyComsParams,
    PostRequestTestFakeServiceStatusParams,
    PostRequestTestFullScreenCardBodies,
    PostRequestTestFullScreenCardParams,
    PostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeParams,
    PostRequestTestLocaleParams,
    PostRequestTestPokeLongpollerParams,
    PostRequestTestResetTempFakeStipeCountryParams,
    PostRequestTestSearchRolloutByUsernameParams,
    PostRequestTestSendCollectionPushNotificationBodies,
    PostRequestTestSendCollectionPushNotificationParams,
    PostRequestTestSendPushNotificationBodies,
    PostRequestTestSendPushNotificationParams,
    PostRequestTestSunsetComsParams,
    PostRequestTestSunsetDeleteParams,
    PostRequestTestThrowawayUserBodies,
    PostRequestTestThrowawayUserParams,
    PostRequestTestThrowawayUserTemplateByJobUuidParams,
    PostRequestTestUserEventParams,
    PrivateShareRespDTO,
    SaveTemplateRespDTO,
    SendCsamRespDTO,
    SendPushRespDTO,
    ThrowawayAccountRespDTO,
    UndoDeletionRequestRespDTO,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * This call allows the clients to send in the locale value. The backend
performs the check and fix locale operation. The client returns the
value after check and fix locale operation has been completed.

 * @summary Test Locale
 */
export const postRequestTestLocale = (
    params: PostRequestTestLocaleParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<LocaleRespDTO>(
        { url: `/test/locale`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestTestLocaleMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestLocale>>,
        TError,
        { params: PostRequestTestLocaleParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestLocale>>,
    TError,
    { params: PostRequestTestLocaleParams },
    TContext
> => {
    const mutationKey = ['postRequestTestLocale']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestLocale>>,
        { params: PostRequestTestLocaleParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestLocale(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestLocaleMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestLocale>>
>

export type PostRequestTestLocaleMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Test Locale
 */
export const usePostRequestTestLocale = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestLocale>>,
            TError,
            { params: PostRequestTestLocaleParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestLocale>>,
    TError,
    { params: PostRequestTestLocaleParams },
    TContext
> => {
    const mutationOptions = getPostRequestTestLocaleMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * This test function deletes the original file in the cache + thumbnails
size 256-80 and -1280 For video it does not remove the encoded video
from cache

 * @summary Test Cache Remove
 */
export const postRequestTestCacheRemoveByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/test/cache-remove/${encodeURIComponent(String(jobUuid))}/${encodeURIComponent(String(fileUuid))}`,
            method: 'POST',
            signal,
        },
        options,
    )
}

export const getPostRequestTestCacheRemoveByJobUuidAndFileUuidMutationOptions =
    <TError = ErrorType<HTTPValidationErrorDTO>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestTestCacheRemoveByJobUuidAndFileUuid
                >
            >,
            TError,
            { jobUuid: string; fileUuid: string },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<typeof postRequestTestCacheRemoveByJobUuidAndFileUuid>
        >,
        TError,
        { jobUuid: string; fileUuid: string },
        TContext
    > => {
        const mutationKey = ['postRequestTestCacheRemoveByJobUuidAndFileUuid']
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestTestCacheRemoveByJobUuidAndFileUuid
                >
            >,
            { jobUuid: string; fileUuid: string }
        > = (props) => {
            const { jobUuid, fileUuid } = props ?? {}

            return postRequestTestCacheRemoveByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestTestCacheRemoveByJobUuidAndFileUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof postRequestTestCacheRemoveByJobUuidAndFileUuid>
        >
    >

export type PostRequestTestCacheRemoveByJobUuidAndFileUuidMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Test Cache Remove
 */
export const usePostRequestTestCacheRemoveByJobUuidAndFileUuid = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestTestCacheRemoveByJobUuidAndFileUuid
                >
            >,
            TError,
            { jobUuid: string; fileUuid: string },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestCacheRemoveByJobUuidAndFileUuid>>,
    TError,
    { jobUuid: string; fileUuid: string },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestCacheRemoveByJobUuidAndFileUuidMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * TODO: Add information
  The meaning of this call is to check if a thumbnail is in cache and
  storage. But now we only test if the thumbnail is in storage.

 * @summary Verify Thumbs
 */
export const postRequestTestVerifyThumbsByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/test/verify-thumbs/${encodeURIComponent(String(jobUuid))}/${encodeURIComponent(String(fileUuid))}`,
            method: 'POST',
            signal,
        },
        options,
    )
}

export const getPostRequestTestVerifyThumbsByJobUuidAndFileUuidMutationOptions =
    <TError = ErrorType<HTTPValidationErrorDTO>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestTestVerifyThumbsByJobUuidAndFileUuid
                >
            >,
            TError,
            { jobUuid: string; fileUuid: string },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<typeof postRequestTestVerifyThumbsByJobUuidAndFileUuid>
        >,
        TError,
        { jobUuid: string; fileUuid: string },
        TContext
    > => {
        const mutationKey = ['postRequestTestVerifyThumbsByJobUuidAndFileUuid']
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestTestVerifyThumbsByJobUuidAndFileUuid
                >
            >,
            { jobUuid: string; fileUuid: string }
        > = (props) => {
            const { jobUuid, fileUuid } = props ?? {}

            return postRequestTestVerifyThumbsByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestTestVerifyThumbsByJobUuidAndFileUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof postRequestTestVerifyThumbsByJobUuidAndFileUuid>
        >
    >

export type PostRequestTestVerifyThumbsByJobUuidAndFileUuidMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Verify Thumbs
 */
export const usePostRequestTestVerifyThumbsByJobUuidAndFileUuid = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestTestVerifyThumbsByJobUuidAndFileUuid
                >
            >,
            TError,
            { jobUuid: string; fileUuid: string },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestVerifyThumbsByJobUuidAndFileUuid>>,
    TError,
    { jobUuid: string; fileUuid: string },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestVerifyThumbsByJobUuidAndFileUuidMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Verify Thumbs Cache
 */
export const postRequestTestVerifyThumbsCacheByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/test/verify-thumbs-cache/${encodeURIComponent(String(jobUuid))}/${encodeURIComponent(String(fileUuid))}`,
            method: 'POST',
            signal,
        },
        options,
    )
}

export const getPostRequestTestVerifyThumbsCacheByJobUuidAndFileUuidMutationOptions =
    <TError = ErrorType<HTTPValidationErrorDTO>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestTestVerifyThumbsCacheByJobUuidAndFileUuid
                >
            >,
            TError,
            { jobUuid: string; fileUuid: string },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof postRequestTestVerifyThumbsCacheByJobUuidAndFileUuid
            >
        >,
        TError,
        { jobUuid: string; fileUuid: string },
        TContext
    > => {
        const mutationKey = [
            'postRequestTestVerifyThumbsCacheByJobUuidAndFileUuid',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestTestVerifyThumbsCacheByJobUuidAndFileUuid
                >
            >,
            { jobUuid: string; fileUuid: string }
        > = (props) => {
            const { jobUuid, fileUuid } = props ?? {}

            return postRequestTestVerifyThumbsCacheByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestTestVerifyThumbsCacheByJobUuidAndFileUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof postRequestTestVerifyThumbsCacheByJobUuidAndFileUuid
            >
        >
    >

export type PostRequestTestVerifyThumbsCacheByJobUuidAndFileUuidMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Verify Thumbs Cache
 */
export const usePostRequestTestVerifyThumbsCacheByJobUuidAndFileUuid = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestTestVerifyThumbsCacheByJobUuidAndFileUuid
                >
            >,
            TError,
            { jobUuid: string; fileUuid: string },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<typeof postRequestTestVerifyThumbsCacheByJobUuidAndFileUuid>
    >,
    TError,
    { jobUuid: string; fileUuid: string },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestVerifyThumbsCacheByJobUuidAndFileUuidMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Verify Thumbs Storage
 */
export const postRequestTestVerifyThumbsStorageByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/test/verify-thumbs-storage/${encodeURIComponent(String(jobUuid))}/${encodeURIComponent(String(fileUuid))}`,
            method: 'POST',
            signal,
        },
        options,
    )
}

export const getPostRequestTestVerifyThumbsStorageByJobUuidAndFileUuidMutationOptions =
    <TError = ErrorType<HTTPValidationErrorDTO>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestTestVerifyThumbsStorageByJobUuidAndFileUuid
                >
            >,
            TError,
            { jobUuid: string; fileUuid: string },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof postRequestTestVerifyThumbsStorageByJobUuidAndFileUuid
            >
        >,
        TError,
        { jobUuid: string; fileUuid: string },
        TContext
    > => {
        const mutationKey = [
            'postRequestTestVerifyThumbsStorageByJobUuidAndFileUuid',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestTestVerifyThumbsStorageByJobUuidAndFileUuid
                >
            >,
            { jobUuid: string; fileUuid: string }
        > = (props) => {
            const { jobUuid, fileUuid } = props ?? {}

            return postRequestTestVerifyThumbsStorageByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestTestVerifyThumbsStorageByJobUuidAndFileUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof postRequestTestVerifyThumbsStorageByJobUuidAndFileUuid
            >
        >
    >

export type PostRequestTestVerifyThumbsStorageByJobUuidAndFileUuidMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Verify Thumbs Storage
 */
export const usePostRequestTestVerifyThumbsStorageByJobUuidAndFileUuid = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestTestVerifyThumbsStorageByJobUuidAndFileUuid
                >
            >,
            TError,
            { jobUuid: string; fileUuid: string },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<
            typeof postRequestTestVerifyThumbsStorageByJobUuidAndFileUuid
        >
    >,
    TError,
    { jobUuid: string; fileUuid: string },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestVerifyThumbsStorageByJobUuidAndFileUuidMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Test Delete All Files
 */
export const postRequestTestJobDeleteAllFilesByJobUuid = (
    jobUuid: string,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<DeleteFilesRespDTO>(
        {
            url: `/test/job/${encodeURIComponent(String(jobUuid))}/delete-all-files`,
            method: 'POST',
            signal,
        },
        options,
    )
}

export const getPostRequestTestJobDeleteAllFilesByJobUuidMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestJobDeleteAllFilesByJobUuid>>,
        TError,
        { jobUuid: string },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestJobDeleteAllFilesByJobUuid>>,
    TError,
    { jobUuid: string },
    TContext
> => {
    const mutationKey = ['postRequestTestJobDeleteAllFilesByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestJobDeleteAllFilesByJobUuid>>,
        { jobUuid: string }
    > = (props) => {
        const { jobUuid } = props ?? {}

        return postRequestTestJobDeleteAllFilesByJobUuid(
            jobUuid,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestJobDeleteAllFilesByJobUuidMutationResult =
    NonNullable<
        Awaited<ReturnType<typeof postRequestTestJobDeleteAllFilesByJobUuid>>
    >

export type PostRequestTestJobDeleteAllFilesByJobUuidMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Test Delete All Files
 */
export const usePostRequestTestJobDeleteAllFilesByJobUuid = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<typeof postRequestTestJobDeleteAllFilesByJobUuid>
            >,
            TError,
            { jobUuid: string },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestJobDeleteAllFilesByJobUuid>>,
    TError,
    { jobUuid: string },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestJobDeleteAllFilesByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Make Throwaway User
 */
export const postRequestTestThrowawayUser = (
    postRequestTestThrowawayUserBodies: BodyType<PostRequestTestThrowawayUserBodies>,
    params: PostRequestTestThrowawayUserParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<ThrowawayAccountRespDTO>(
        {
            url: `/test/throwaway_user`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestTestThrowawayUserBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestTestThrowawayUserMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestThrowawayUser>>,
        TError,
        {
            data: BodyType<PostRequestTestThrowawayUserBodies>
            params: PostRequestTestThrowawayUserParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestThrowawayUser>>,
    TError,
    {
        data: BodyType<PostRequestTestThrowawayUserBodies>
        params: PostRequestTestThrowawayUserParams
    },
    TContext
> => {
    const mutationKey = ['postRequestTestThrowawayUser']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestThrowawayUser>>,
        {
            data: BodyType<PostRequestTestThrowawayUserBodies>
            params: PostRequestTestThrowawayUserParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestTestThrowawayUser(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestThrowawayUserMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestThrowawayUser>>
>
export type PostRequestTestThrowawayUserMutationBody =
    BodyType<PostRequestTestThrowawayUserBodies>
export type PostRequestTestThrowawayUserMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Make Throwaway User
 */
export const usePostRequestTestThrowawayUser = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestThrowawayUser>>,
            TError,
            {
                data: BodyType<PostRequestTestThrowawayUserBodies>
                params: PostRequestTestThrowawayUserParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestThrowawayUser>>,
    TError,
    {
        data: BodyType<PostRequestTestThrowawayUserBodies>
        params: PostRequestTestThrowawayUserParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestThrowawayUserMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Save Throwaway Template
 */
export const postRequestTestThrowawayUserTemplateByJobUuid = (
    jobUuid: string,
    params: PostRequestTestThrowawayUserTemplateByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SaveTemplateRespDTO>(
        {
            url: `/test/throwaway_user_template/${encodeURIComponent(String(jobUuid))}`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestTestThrowawayUserTemplateByJobUuidMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<typeof postRequestTestThrowawayUserTemplateByJobUuid>
        >,
        TError,
        {
            jobUuid: string
            params: PostRequestTestThrowawayUserTemplateByJobUuidParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestThrowawayUserTemplateByJobUuid>>,
    TError,
    {
        jobUuid: string
        params: PostRequestTestThrowawayUserTemplateByJobUuidParams
    },
    TContext
> => {
    const mutationKey = ['postRequestTestThrowawayUserTemplateByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<typeof postRequestTestThrowawayUserTemplateByJobUuid>
        >,
        {
            jobUuid: string
            params: PostRequestTestThrowawayUserTemplateByJobUuidParams
        }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestTestThrowawayUserTemplateByJobUuid(
            jobUuid,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestThrowawayUserTemplateByJobUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof postRequestTestThrowawayUserTemplateByJobUuid>
        >
    >

export type PostRequestTestThrowawayUserTemplateByJobUuidMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Save Throwaway Template
 */
export const usePostRequestTestThrowawayUserTemplateByJobUuid = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<typeof postRequestTestThrowawayUserTemplateByJobUuid>
            >,
            TError,
            {
                jobUuid: string
                params: PostRequestTestThrowawayUserTemplateByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestThrowawayUserTemplateByJobUuid>>,
    TError,
    {
        jobUuid: string
        params: PostRequestTestThrowawayUserTemplateByJobUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestThrowawayUserTemplateByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Delete Throwaway Template
 */
export const deleteRequestTestThrowawayUserTemplate = (
    params: DeleteRequestTestThrowawayUserTemplateParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<DeleteTemplateRespDTO>(
        { url: `/test/throwaway_user_template`, method: 'DELETE', params },
        options,
    )
}

export const getDeleteRequestTestThrowawayUserTemplateMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestTestThrowawayUserTemplate>>,
        TError,
        { params: DeleteRequestTestThrowawayUserTemplateParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestTestThrowawayUserTemplate>>,
    TError,
    { params: DeleteRequestTestThrowawayUserTemplateParams },
    TContext
> => {
    const mutationKey = ['deleteRequestTestThrowawayUserTemplate']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestTestThrowawayUserTemplate>>,
        { params: DeleteRequestTestThrowawayUserTemplateParams }
    > = (props) => {
        const { params } = props ?? {}

        return deleteRequestTestThrowawayUserTemplate(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestTestThrowawayUserTemplateMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestTestThrowawayUserTemplate>>
>

export type DeleteRequestTestThrowawayUserTemplateMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Delete Throwaway Template
 */
export const useDeleteRequestTestThrowawayUserTemplate = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestTestThrowawayUserTemplate>>,
            TError,
            { params: DeleteRequestTestThrowawayUserTemplateParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestTestThrowawayUserTemplate>>,
    TError,
    { params: DeleteRequestTestThrowawayUserTemplateParams },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestTestThrowawayUserTemplateMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Rollout User To Search
 */
export const postRequestTestSearchRolloutByUsername = (
    username: string,
    params?: PostRequestTestSearchRolloutByUsernameParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/test/search_rollout/${encodeURIComponent(String(username))}`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestTestSearchRolloutByUsernameMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestSearchRolloutByUsername>>,
        TError,
        {
            username: string
            params?: PostRequestTestSearchRolloutByUsernameParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestSearchRolloutByUsername>>,
    TError,
    { username: string; params?: PostRequestTestSearchRolloutByUsernameParams },
    TContext
> => {
    const mutationKey = ['postRequestTestSearchRolloutByUsername']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestSearchRolloutByUsername>>,
        {
            username: string
            params?: PostRequestTestSearchRolloutByUsernameParams
        }
    > = (props) => {
        const { username, params } = props ?? {}

        return postRequestTestSearchRolloutByUsername(
            username,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestSearchRolloutByUsernameMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestSearchRolloutByUsername>>
>

export type PostRequestTestSearchRolloutByUsernameMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Rollout User To Search
 */
export const usePostRequestTestSearchRolloutByUsername = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestSearchRolloutByUsername>>,
            TError,
            {
                username: string
                params?: PostRequestTestSearchRolloutByUsernameParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestSearchRolloutByUsername>>,
    TError,
    { username: string; params?: PostRequestTestSearchRolloutByUsernameParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestSearchRolloutByUsernameMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Allow developers to send push notification to device via the backend

 * @summary Send Push Notification Handler
 */
export const postRequestTestSendPushNotification = (
    postRequestTestSendPushNotificationBodies: BodyType<PostRequestTestSendPushNotificationBodies>,
    params: PostRequestTestSendPushNotificationParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SendPushRespDTO>(
        {
            url: `/test/send_push_notification`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestTestSendPushNotificationBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestTestSendPushNotificationMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestSendPushNotification>>,
        TError,
        {
            data: BodyType<PostRequestTestSendPushNotificationBodies>
            params: PostRequestTestSendPushNotificationParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestSendPushNotification>>,
    TError,
    {
        data: BodyType<PostRequestTestSendPushNotificationBodies>
        params: PostRequestTestSendPushNotificationParams
    },
    TContext
> => {
    const mutationKey = ['postRequestTestSendPushNotification']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestSendPushNotification>>,
        {
            data: BodyType<PostRequestTestSendPushNotificationBodies>
            params: PostRequestTestSendPushNotificationParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestTestSendPushNotification(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestSendPushNotificationMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestSendPushNotification>>
>
export type PostRequestTestSendPushNotificationMutationBody =
    BodyType<PostRequestTestSendPushNotificationBodies>
export type PostRequestTestSendPushNotificationMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Send Push Notification Handler
 */
export const usePostRequestTestSendPushNotification = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestSendPushNotification>>,
            TError,
            {
                data: BodyType<PostRequestTestSendPushNotificationBodies>
                params: PostRequestTestSendPushNotificationParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestSendPushNotification>>,
    TError,
    {
        data: BodyType<PostRequestTestSendPushNotificationBodies>
        params: PostRequestTestSendPushNotificationParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestSendPushNotificationMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Allow developers to send push notification to device for different collections via the backend

 * @summary Send Collection Push
 */
export const postRequestTestSendCollectionPushNotification = (
    postRequestTestSendCollectionPushNotificationBodies: BodyType<PostRequestTestSendCollectionPushNotificationBodies>,
    params: PostRequestTestSendCollectionPushNotificationParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SendPushRespDTO>(
        {
            url: `/test/send_collection_push_notification`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestTestSendCollectionPushNotificationBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestTestSendCollectionPushNotificationMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<typeof postRequestTestSendCollectionPushNotification>
        >,
        TError,
        {
            data: BodyType<PostRequestTestSendCollectionPushNotificationBodies>
            params: PostRequestTestSendCollectionPushNotificationParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestSendCollectionPushNotification>>,
    TError,
    {
        data: BodyType<PostRequestTestSendCollectionPushNotificationBodies>
        params: PostRequestTestSendCollectionPushNotificationParams
    },
    TContext
> => {
    const mutationKey = ['postRequestTestSendCollectionPushNotification']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<typeof postRequestTestSendCollectionPushNotification>
        >,
        {
            data: BodyType<PostRequestTestSendCollectionPushNotificationBodies>
            params: PostRequestTestSendCollectionPushNotificationParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestTestSendCollectionPushNotification(
            data,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestSendCollectionPushNotificationMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof postRequestTestSendCollectionPushNotification>
        >
    >
export type PostRequestTestSendCollectionPushNotificationMutationBody =
    BodyType<PostRequestTestSendCollectionPushNotificationBodies>
export type PostRequestTestSendCollectionPushNotificationMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Send Collection Push
 */
export const usePostRequestTestSendCollectionPushNotification = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<typeof postRequestTestSendCollectionPushNotification>
            >,
            TError,
            {
                data: BodyType<PostRequestTestSendCollectionPushNotificationBodies>
                params: PostRequestTestSendCollectionPushNotificationParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestSendCollectionPushNotification>>,
    TError,
    {
        data: BodyType<PostRequestTestSendCollectionPushNotificationBodies>
        params: PostRequestTestSendCollectionPushNotificationParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestSendCollectionPushNotificationMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Erase Store Sub
 */
export const deleteRequestTestEraseStoreSub = (
    params: DeleteRequestTestEraseStoreSubParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>(
        { url: `/test/erase_store_sub`, method: 'DELETE', params },
        options,
    )
}

export const getDeleteRequestTestEraseStoreSubMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestTestEraseStoreSub>>,
        TError,
        { params: DeleteRequestTestEraseStoreSubParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestTestEraseStoreSub>>,
    TError,
    { params: DeleteRequestTestEraseStoreSubParams },
    TContext
> => {
    const mutationKey = ['deleteRequestTestEraseStoreSub']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestTestEraseStoreSub>>,
        { params: DeleteRequestTestEraseStoreSubParams }
    > = (props) => {
        const { params } = props ?? {}

        return deleteRequestTestEraseStoreSub(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestTestEraseStoreSubMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestTestEraseStoreSub>>
>

export type DeleteRequestTestEraseStoreSubMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Erase Store Sub
 */
export const useDeleteRequestTestEraseStoreSub = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestTestEraseStoreSub>>,
            TError,
            { params: DeleteRequestTestEraseStoreSubParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestTestEraseStoreSub>>,
    TError,
    { params: DeleteRequestTestEraseStoreSubParams },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestTestEraseStoreSubMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Remove Non Default Grants
 */
export const deleteRequestTestRemoveNonDefaultGrants = (
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<DeleteRequestTestRemoveNonDefaultGrants200>(
        { url: `/test/remove_non_default_grants`, method: 'DELETE' },
        options,
    )
}

export const getDeleteRequestTestRemoveNonDefaultGrantsMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestTestRemoveNonDefaultGrants>>,
        TError,
        void,
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestTestRemoveNonDefaultGrants>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ['deleteRequestTestRemoveNonDefaultGrants']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestTestRemoveNonDefaultGrants>>,
        void
    > = () => {
        return deleteRequestTestRemoveNonDefaultGrants(requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestTestRemoveNonDefaultGrantsMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestTestRemoveNonDefaultGrants>>
>

export type DeleteRequestTestRemoveNonDefaultGrantsMutationError =
    ErrorType<unknown>

/**
 * @summary Remove Non Default Grants
 */
export const useDeleteRequestTestRemoveNonDefaultGrants = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestTestRemoveNonDefaultGrants>>,
            TError,
            void,
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestTestRemoveNonDefaultGrants>>,
    TError,
    void,
    TContext
> => {
    const mutationOptions =
        getDeleteRequestTestRemoveNonDefaultGrantsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Add Grant
 */
export const postRequestTestAddGrant = (
    params: PostRequestTestAddGrantParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/test/add_grant`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestTestAddGrantMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestAddGrant>>,
        TError,
        { params: PostRequestTestAddGrantParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestAddGrant>>,
    TError,
    { params: PostRequestTestAddGrantParams },
    TContext
> => {
    const mutationKey = ['postRequestTestAddGrant']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestAddGrant>>,
        { params: PostRequestTestAddGrantParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestAddGrant(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestAddGrantMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestAddGrant>>
>

export type PostRequestTestAddGrantMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Add Grant
 */
export const usePostRequestTestAddGrant = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestAddGrant>>,
            TError,
            { params: PostRequestTestAddGrantParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestAddGrant>>,
    TError,
    { params: PostRequestTestAddGrantParams },
    TContext
> => {
    const mutationOptions = getPostRequestTestAddGrantMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Login Identifier
 */
export const getRequestTestLoginIdentifier = (
    params: GetRequestTestLoginIdentifierParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<LoginIdentifierRespDTO>(
        { url: `/test/login_identifier`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestTestLoginIdentifierQueryKey = (
    params?: GetRequestTestLoginIdentifierParams,
) => {
    return [`/test/login_identifier`, ...(params ? [params] : [])] as const
}

export const getGetRequestTestLoginIdentifierQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestLoginIdentifierParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestTestLoginIdentifierQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>
    > = ({ signal }) =>
        getRequestTestLoginIdentifier(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestTestLoginIdentifierQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>
>
export type GetRequestTestLoginIdentifierQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestTestLoginIdentifier<
    TData = Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestLoginIdentifierParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestTestLoginIdentifier<
    TData = Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestLoginIdentifierParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestTestLoginIdentifier<
    TData = Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestLoginIdentifierParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Login Identifier
 */

export function useGetRequestTestLoginIdentifier<
    TData = Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestLoginIdentifierParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestLoginIdentifier>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestTestLoginIdentifierQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * @summary Create Private Share
 */
export const postRequestTestPrivateShare = (
    bodyCreatePrivateShareTestPrivateSharePostDTO: BodyType<BodyCreatePrivateShareTestPrivateSharePostDTO>,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PrivateShareRespDTO>(
        {
            url: `/test/private_share`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: bodyCreatePrivateShareTestPrivateSharePostDTO,
            signal,
        },
        options,
    )
}

export const getPostRequestTestPrivateShareMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestPrivateShare>>,
        TError,
        { data: BodyType<BodyCreatePrivateShareTestPrivateSharePostDTO> },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestPrivateShare>>,
    TError,
    { data: BodyType<BodyCreatePrivateShareTestPrivateSharePostDTO> },
    TContext
> => {
    const mutationKey = ['postRequestTestPrivateShare']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestPrivateShare>>,
        { data: BodyType<BodyCreatePrivateShareTestPrivateSharePostDTO> }
    > = (props) => {
        const { data } = props ?? {}

        return postRequestTestPrivateShare(data, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestPrivateShareMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestPrivateShare>>
>
export type PostRequestTestPrivateShareMutationBody =
    BodyType<BodyCreatePrivateShareTestPrivateSharePostDTO>
export type PostRequestTestPrivateShareMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Create Private Share
 */
export const usePostRequestTestPrivateShare = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestPrivateShare>>,
            TError,
            { data: BodyType<BodyCreatePrivateShareTestPrivateSharePostDTO> },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestPrivateShare>>,
    TError,
    { data: BodyType<BodyCreatePrivateShareTestPrivateSharePostDTO> },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestPrivateShareMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Undo Requested Delete
 */
export const postRequestTestUndoRequestedDeleteByUsername = (
    username: string,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<UndoDeletionRequestRespDTO>(
        {
            url: `/test/undo_requested_delete/${encodeURIComponent(String(username))}`,
            method: 'POST',
            signal,
        },
        options,
    )
}

export const getPostRequestTestUndoRequestedDeleteByUsernameMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<typeof postRequestTestUndoRequestedDeleteByUsername>
        >,
        TError,
        { username: string },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestUndoRequestedDeleteByUsername>>,
    TError,
    { username: string },
    TContext
> => {
    const mutationKey = ['postRequestTestUndoRequestedDeleteByUsername']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<typeof postRequestTestUndoRequestedDeleteByUsername>
        >,
        { username: string }
    > = (props) => {
        const { username } = props ?? {}

        return postRequestTestUndoRequestedDeleteByUsername(
            username,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestUndoRequestedDeleteByUsernameMutationResult =
    NonNullable<
        Awaited<ReturnType<typeof postRequestTestUndoRequestedDeleteByUsername>>
    >

export type PostRequestTestUndoRequestedDeleteByUsernameMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Undo Requested Delete
 */
export const usePostRequestTestUndoRequestedDeleteByUsername = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<typeof postRequestTestUndoRequestedDeleteByUsername>
            >,
            TError,
            { username: string },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestUndoRequestedDeleteByUsername>>,
    TError,
    { username: string },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestUndoRequestedDeleteByUsernameMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Create Dummy Signed Jwt
 */
export const getRequestTestCreateDummySignedJwt = (
    params: GetRequestTestCreateDummySignedJwtParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<DummyPoliceJwtRespDTO>(
        { url: `/test/create_dummy_signed_jwt`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestTestCreateDummySignedJwtQueryKey = (
    params?: GetRequestTestCreateDummySignedJwtParams,
) => {
    return [
        `/test/create_dummy_signed_jwt`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestTestCreateDummySignedJwtQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestCreateDummySignedJwtParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestTestCreateDummySignedJwtQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>
    > = ({ signal }) =>
        getRequestTestCreateDummySignedJwt(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestTestCreateDummySignedJwtQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>
>
export type GetRequestTestCreateDummySignedJwtQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestTestCreateDummySignedJwt<
    TData = Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestCreateDummySignedJwtParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestTestCreateDummySignedJwt>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRequestTestCreateDummySignedJwt>
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestTestCreateDummySignedJwt<
    TData = Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestCreateDummySignedJwtParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestTestCreateDummySignedJwt>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRequestTestCreateDummySignedJwt>
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestTestCreateDummySignedJwt<
    TData = Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestCreateDummySignedJwtParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Create Dummy Signed Jwt
 */

export function useGetRequestTestCreateDummySignedJwt<
    TData = Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestCreateDummySignedJwtParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestCreateDummySignedJwt>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestTestCreateDummySignedJwtQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * @summary Send Csam Report
 */
export const postRequestTestSendCsamReport = (
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SendCsamRespDTO>(
        { url: `/test/send_csam_report`, method: 'POST', signal },
        options,
    )
}

export const getPostRequestTestSendCsamReportMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestSendCsamReport>>,
        TError,
        void,
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestSendCsamReport>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ['postRequestTestSendCsamReport']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestSendCsamReport>>,
        void
    > = () => {
        return postRequestTestSendCsamReport(requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestSendCsamReportMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestSendCsamReport>>
>

export type PostRequestTestSendCsamReportMutationError = ErrorType<unknown>

/**
 * @summary Send Csam Report
 */
export const usePostRequestTestSendCsamReport = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestSendCsamReport>>,
            TError,
            void,
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestSendCsamReport>>,
    TError,
    void,
    TContext
> => {
    const mutationOptions =
        getPostRequestTestSendCsamReportMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Delete Stripe Data
 */
export const postRequestTestDeleteStripeData = (
    params: PostRequestTestDeleteStripeDataParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/test/delete_stripe_data`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestTestDeleteStripeDataMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestDeleteStripeData>>,
        TError,
        { params: PostRequestTestDeleteStripeDataParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestDeleteStripeData>>,
    TError,
    { params: PostRequestTestDeleteStripeDataParams },
    TContext
> => {
    const mutationKey = ['postRequestTestDeleteStripeData']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestDeleteStripeData>>,
        { params: PostRequestTestDeleteStripeDataParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestDeleteStripeData(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestDeleteStripeDataMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestDeleteStripeData>>
>

export type PostRequestTestDeleteStripeDataMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Delete Stripe Data
 */
export const usePostRequestTestDeleteStripeData = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestDeleteStripeData>>,
            TError,
            { params: PostRequestTestDeleteStripeDataParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestDeleteStripeData>>,
    TError,
    { params: PostRequestTestDeleteStripeDataParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestDeleteStripeDataMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Add Full Screen Card
 */
export const postRequestTestFullScreenCard = (
    postRequestTestFullScreenCardBodies: BodyType<PostRequestTestFullScreenCardBodies>,
    params: PostRequestTestFullScreenCardParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        {
            url: `/test/full_screen_card`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestTestFullScreenCardBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestTestFullScreenCardMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestFullScreenCard>>,
        TError,
        {
            data: BodyType<PostRequestTestFullScreenCardBodies>
            params: PostRequestTestFullScreenCardParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestFullScreenCard>>,
    TError,
    {
        data: BodyType<PostRequestTestFullScreenCardBodies>
        params: PostRequestTestFullScreenCardParams
    },
    TContext
> => {
    const mutationKey = ['postRequestTestFullScreenCard']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestFullScreenCard>>,
        {
            data: BodyType<PostRequestTestFullScreenCardBodies>
            params: PostRequestTestFullScreenCardParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestTestFullScreenCard(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestFullScreenCardMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestFullScreenCard>>
>
export type PostRequestTestFullScreenCardMutationBody =
    BodyType<PostRequestTestFullScreenCardBodies>
export type PostRequestTestFullScreenCardMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Add Full Screen Card
 */
export const usePostRequestTestFullScreenCard = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestFullScreenCard>>,
            TError,
            {
                data: BodyType<PostRequestTestFullScreenCardBodies>
                params: PostRequestTestFullScreenCardParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestFullScreenCard>>,
    TError,
    {
        data: BodyType<PostRequestTestFullScreenCardBodies>
        params: PostRequestTestFullScreenCardParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestFullScreenCardMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Create Memory Collection
 */
export const postRequestTestJobsMemoryCollectionsByJobUuidAndCollectionType = (
    jobUuid: string,
    collectionType: CollectionTypeDTO,
    params: PostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/test/jobs/${encodeURIComponent(String(jobUuid))}/memory_collections/${encodeURIComponent(String(collectionType))}`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeMutationOptions =
    <TError = ErrorType<HTTPValidationErrorDTO>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestTestJobsMemoryCollectionsByJobUuidAndCollectionType
                >
            >,
            TError,
            {
                jobUuid: string
                collectionType: CollectionTypeDTO
                params: PostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof postRequestTestJobsMemoryCollectionsByJobUuidAndCollectionType
            >
        >,
        TError,
        {
            jobUuid: string
            collectionType: CollectionTypeDTO
            params: PostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeParams
        },
        TContext
    > => {
        const mutationKey = [
            'postRequestTestJobsMemoryCollectionsByJobUuidAndCollectionType',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestTestJobsMemoryCollectionsByJobUuidAndCollectionType
                >
            >,
            {
                jobUuid: string
                collectionType: CollectionTypeDTO
                params: PostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeParams
            }
        > = (props) => {
            const { jobUuid, collectionType, params } = props ?? {}

            return postRequestTestJobsMemoryCollectionsByJobUuidAndCollectionType(
                jobUuid,
                collectionType,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof postRequestTestJobsMemoryCollectionsByJobUuidAndCollectionType
            >
        >
    >

export type PostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Create Memory Collection
 */
export const usePostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionType =
    <TError = ErrorType<HTTPValidationErrorDTO>, TContext = unknown>(
        options?: {
            mutation?: UseMutationOptions<
                Awaited<
                    ReturnType<
                        typeof postRequestTestJobsMemoryCollectionsByJobUuidAndCollectionType
                    >
                >,
                TError,
                {
                    jobUuid: string
                    collectionType: CollectionTypeDTO
                    params: PostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeParams
                },
                TContext
            >
            request?: SecondParameter<typeof customInstance>
        },
        queryClient?: QueryClient,
    ): UseMutationResult<
        Awaited<
            ReturnType<
                typeof postRequestTestJobsMemoryCollectionsByJobUuidAndCollectionType
            >
        >,
        TError,
        {
            jobUuid: string
            collectionType: CollectionTypeDTO
            params: PostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeParams
        },
        TContext
    > => {
        const mutationOptions =
            getPostRequestTestJobsMemoryCollectionsByJobUuidAndCollectionTypeMutationOptions(
                options,
            )

        return useMutation(mutationOptions, queryClient)
    }
/**
 * @summary Get Memory Collection
 */
export const getRequestTestMemoryCollectionsByCollectionUuid = (
    collectionUuid: string,
    params: GetRequestTestMemoryCollectionsByCollectionUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<CollectionDTO>(
        {
            url: `/test/memory_collections/${encodeURIComponent(String(collectionUuid))}`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestTestMemoryCollectionsByCollectionUuidQueryKey = (
    collectionUuid?: string,
    params?: GetRequestTestMemoryCollectionsByCollectionUuidParams,
) => {
    return [
        `/test/memory_collections/${collectionUuid}`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestTestMemoryCollectionsByCollectionUuidQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getRequestTestMemoryCollectionsByCollectionUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    collectionUuid: string,
    params: GetRequestTestMemoryCollectionsByCollectionUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestTestMemoryCollectionsByCollectionUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestTestMemoryCollectionsByCollectionUuidQueryKey(
            collectionUuid,
            params,
        )

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<typeof getRequestTestMemoryCollectionsByCollectionUuid>
        >
    > = ({ signal }) =>
        getRequestTestMemoryCollectionsByCollectionUuid(
            collectionUuid,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!collectionUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<typeof getRequestTestMemoryCollectionsByCollectionUuid>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestTestMemoryCollectionsByCollectionUuidQueryResult =
    NonNullable<
        Awaited<
            ReturnType<typeof getRequestTestMemoryCollectionsByCollectionUuid>
        >
    >
export type GetRequestTestMemoryCollectionsByCollectionUuidQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestTestMemoryCollectionsByCollectionUuid<
    TData = Awaited<
        ReturnType<typeof getRequestTestMemoryCollectionsByCollectionUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    collectionUuid: string,
    params: GetRequestTestMemoryCollectionsByCollectionUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestTestMemoryCollectionsByCollectionUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestTestMemoryCollectionsByCollectionUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestTestMemoryCollectionsByCollectionUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestTestMemoryCollectionsByCollectionUuid<
    TData = Awaited<
        ReturnType<typeof getRequestTestMemoryCollectionsByCollectionUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    collectionUuid: string,
    params: GetRequestTestMemoryCollectionsByCollectionUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestTestMemoryCollectionsByCollectionUuid
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestTestMemoryCollectionsByCollectionUuid
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestTestMemoryCollectionsByCollectionUuid
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestTestMemoryCollectionsByCollectionUuid<
    TData = Awaited<
        ReturnType<typeof getRequestTestMemoryCollectionsByCollectionUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    collectionUuid: string,
    params: GetRequestTestMemoryCollectionsByCollectionUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestTestMemoryCollectionsByCollectionUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Memory Collection
 */

export function useGetRequestTestMemoryCollectionsByCollectionUuid<
    TData = Awaited<
        ReturnType<typeof getRequestTestMemoryCollectionsByCollectionUuid>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    collectionUuid: string,
    params: GetRequestTestMemoryCollectionsByCollectionUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestTestMemoryCollectionsByCollectionUuid
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestTestMemoryCollectionsByCollectionUuidQueryOptions(
            collectionUuid,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * @summary Sunset Coms
 */
export const postRequestTestSunsetComs = (
    params: PostRequestTestSunsetComsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/test/sunset_coms`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestTestSunsetComsMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestSunsetComs>>,
        TError,
        { params: PostRequestTestSunsetComsParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestSunsetComs>>,
    TError,
    { params: PostRequestTestSunsetComsParams },
    TContext
> => {
    const mutationKey = ['postRequestTestSunsetComs']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestSunsetComs>>,
        { params: PostRequestTestSunsetComsParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestSunsetComs(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestSunsetComsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestSunsetComs>>
>

export type PostRequestTestSunsetComsMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Sunset Coms
 */
export const usePostRequestTestSunsetComs = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestSunsetComs>>,
            TError,
            { params: PostRequestTestSunsetComsParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestSunsetComs>>,
    TError,
    { params: PostRequestTestSunsetComsParams },
    TContext
> => {
    const mutationOptions = getPostRequestTestSunsetComsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Sunset Delete User Post
 */
export const postRequestTestSunsetDelete = (
    params: PostRequestTestSunsetDeleteParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/test/sunset_delete`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestTestSunsetDeleteMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestSunsetDelete>>,
        TError,
        { params: PostRequestTestSunsetDeleteParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestSunsetDelete>>,
    TError,
    { params: PostRequestTestSunsetDeleteParams },
    TContext
> => {
    const mutationKey = ['postRequestTestSunsetDelete']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestSunsetDelete>>,
        { params: PostRequestTestSunsetDeleteParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestSunsetDelete(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestSunsetDeleteMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestSunsetDelete>>
>

export type PostRequestTestSunsetDeleteMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Sunset Delete User Post
 */
export const usePostRequestTestSunsetDelete = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestSunsetDelete>>,
            TError,
            { params: PostRequestTestSunsetDeleteParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestSunsetDelete>>,
    TError,
    { params: PostRequestTestSunsetDeleteParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestSunsetDeleteMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Delete User Without Telenor Id Coms
 */
export const postRequestTestDeleteUserWithoutTelenorIdComs = (
    params: PostRequestTestDeleteUserWithoutTelenorIdComsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        {
            url: `/test/delete_user_without_telenor_id_coms`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestTestDeleteUserWithoutTelenorIdComsMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<typeof postRequestTestDeleteUserWithoutTelenorIdComs>
        >,
        TError,
        { params: PostRequestTestDeleteUserWithoutTelenorIdComsParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestDeleteUserWithoutTelenorIdComs>>,
    TError,
    { params: PostRequestTestDeleteUserWithoutTelenorIdComsParams },
    TContext
> => {
    const mutationKey = ['postRequestTestDeleteUserWithoutTelenorIdComs']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<typeof postRequestTestDeleteUserWithoutTelenorIdComs>
        >,
        { params: PostRequestTestDeleteUserWithoutTelenorIdComsParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestDeleteUserWithoutTelenorIdComs(
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestDeleteUserWithoutTelenorIdComsMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof postRequestTestDeleteUserWithoutTelenorIdComs>
        >
    >

export type PostRequestTestDeleteUserWithoutTelenorIdComsMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Delete User Without Telenor Id Coms
 */
export const usePostRequestTestDeleteUserWithoutTelenorIdComs = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<typeof postRequestTestDeleteUserWithoutTelenorIdComs>
            >,
            TError,
            { params: PostRequestTestDeleteUserWithoutTelenorIdComsParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestDeleteUserWithoutTelenorIdComs>>,
    TError,
    { params: PostRequestTestDeleteUserWithoutTelenorIdComsParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestDeleteUserWithoutTelenorIdComsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Set Read Only Grant
 */
export const postRequestTestSetReadOnlyGrant = (
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/test/set_read_only_grant`, method: 'POST', signal },
        options,
    )
}

export const getPostRequestTestSetReadOnlyGrantMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestSetReadOnlyGrant>>,
        TError,
        void,
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestSetReadOnlyGrant>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ['postRequestTestSetReadOnlyGrant']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestSetReadOnlyGrant>>,
        void
    > = () => {
        return postRequestTestSetReadOnlyGrant(requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestSetReadOnlyGrantMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestSetReadOnlyGrant>>
>

export type PostRequestTestSetReadOnlyGrantMutationError = ErrorType<unknown>

/**
 * @summary Set Read Only Grant
 */
export const usePostRequestTestSetReadOnlyGrant = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestSetReadOnlyGrant>>,
            TError,
            void,
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestSetReadOnlyGrant>>,
    TError,
    void,
    TContext
> => {
    const mutationOptions =
        getPostRequestTestSetReadOnlyGrantMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Reset Temp Fake Stipe Country
 */
export const postRequestTestResetTempFakeStipeCountry = (
    params: PostRequestTestResetTempFakeStipeCountryParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        {
            url: `/test/reset_temp_fake_stipe_country`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestTestResetTempFakeStipeCountryMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestResetTempFakeStipeCountry>>,
        TError,
        { params: PostRequestTestResetTempFakeStipeCountryParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestResetTempFakeStipeCountry>>,
    TError,
    { params: PostRequestTestResetTempFakeStipeCountryParams },
    TContext
> => {
    const mutationKey = ['postRequestTestResetTempFakeStipeCountry']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestResetTempFakeStipeCountry>>,
        { params: PostRequestTestResetTempFakeStipeCountryParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestResetTempFakeStipeCountry(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestResetTempFakeStipeCountryMutationResult =
    NonNullable<
        Awaited<ReturnType<typeof postRequestTestResetTempFakeStipeCountry>>
    >

export type PostRequestTestResetTempFakeStipeCountryMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Reset Temp Fake Stipe Country
 */
export const usePostRequestTestResetTempFakeStipeCountry = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<typeof postRequestTestResetTempFakeStipeCountry>
            >,
            TError,
            { params: PostRequestTestResetTempFakeStipeCountryParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestResetTempFakeStipeCountry>>,
    TError,
    { params: PostRequestTestResetTempFakeStipeCountryParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestResetTempFakeStipeCountryMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * For now only force sync event is supported
 * @summary Add User Event
 */
export const postRequestTestUserEvent = (
    params: PostRequestTestUserEventParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/test/user_event`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestTestUserEventMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestUserEvent>>,
        TError,
        { params: PostRequestTestUserEventParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestUserEvent>>,
    TError,
    { params: PostRequestTestUserEventParams },
    TContext
> => {
    const mutationKey = ['postRequestTestUserEvent']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestUserEvent>>,
        { params: PostRequestTestUserEventParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestUserEvent(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestUserEventMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestUserEvent>>
>

export type PostRequestTestUserEventMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Add User Event
 */
export const usePostRequestTestUserEvent = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestUserEvent>>,
            TError,
            { params: PostRequestTestUserEventParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestUserEvent>>,
    TError,
    { params: PostRequestTestUserEventParams },
    TContext
> => {
    const mutationOptions = getPostRequestTestUserEventMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Remove User
 */
export const deleteRequestTestRemoveUser = (
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/test/remove_user`, method: 'DELETE' },
        options,
    )
}

export const getDeleteRequestTestRemoveUserMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestTestRemoveUser>>,
        TError,
        void,
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestTestRemoveUser>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ['deleteRequestTestRemoveUser']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestTestRemoveUser>>,
        void
    > = () => {
        return deleteRequestTestRemoveUser(requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestTestRemoveUserMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestTestRemoveUser>>
>

export type DeleteRequestTestRemoveUserMutationError = ErrorType<unknown>

/**
 * @summary Remove User
 */
export const useDeleteRequestTestRemoveUser = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestTestRemoveUser>>,
            TError,
            void,
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestTestRemoveUser>>,
    TError,
    void,
    TContext
> => {
    const mutationOptions =
        getDeleteRequestTestRemoveUserMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Post Client Params
 */
export const postRequestTestClientParams = (
    params: PostRequestTestClientParamsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PostRequestTestClientParams200>(
        { url: `/test/client_params`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestTestClientParamsMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestClientParams>>,
        TError,
        { params: PostRequestTestClientParamsParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestClientParams>>,
    TError,
    { params: PostRequestTestClientParamsParams },
    TContext
> => {
    const mutationKey = ['postRequestTestClientParams']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestClientParams>>,
        { params: PostRequestTestClientParamsParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestClientParams(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestClientParamsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestClientParams>>
>

export type PostRequestTestClientParamsMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Post Client Params
 */
export const usePostRequestTestClientParams = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestClientParams>>,
            TError,
            { params: PostRequestTestClientParamsParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestClientParams>>,
    TError,
    { params: PostRequestTestClientParamsParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestClientParamsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Digital Legacy Coms
 */
export const postRequestTestDigitalLegacyComs = (
    params: PostRequestTestDigitalLegacyComsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/test/digital_legacy_coms`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestTestDigitalLegacyComsMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestDigitalLegacyComs>>,
        TError,
        { params: PostRequestTestDigitalLegacyComsParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestDigitalLegacyComs>>,
    TError,
    { params: PostRequestTestDigitalLegacyComsParams },
    TContext
> => {
    const mutationKey = ['postRequestTestDigitalLegacyComs']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestDigitalLegacyComs>>,
        { params: PostRequestTestDigitalLegacyComsParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestDigitalLegacyComs(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestDigitalLegacyComsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestDigitalLegacyComs>>
>

export type PostRequestTestDigitalLegacyComsMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Digital Legacy Coms
 */
export const usePostRequestTestDigitalLegacyComs = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestDigitalLegacyComs>>,
            TError,
            { params: PostRequestTestDigitalLegacyComsParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestDigitalLegacyComs>>,
    TError,
    { params: PostRequestTestDigitalLegacyComsParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestDigitalLegacyComsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Fake Service Status
 */
export const postRequestTestFakeServiceStatus = (
    params: PostRequestTestFakeServiceStatusParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        { url: `/test/fake/service_status`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestTestFakeServiceStatusMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestFakeServiceStatus>>,
        TError,
        { params: PostRequestTestFakeServiceStatusParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestFakeServiceStatus>>,
    TError,
    { params: PostRequestTestFakeServiceStatusParams },
    TContext
> => {
    const mutationKey = ['postRequestTestFakeServiceStatus']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestFakeServiceStatus>>,
        { params: PostRequestTestFakeServiceStatusParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestFakeServiceStatus(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestFakeServiceStatusMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestFakeServiceStatus>>
>

export type PostRequestTestFakeServiceStatusMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Fake Service Status
 */
export const usePostRequestTestFakeServiceStatus = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestFakeServiceStatus>>,
            TError,
            { params: PostRequestTestFakeServiceStatusParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestFakeServiceStatus>>,
    TError,
    { params: PostRequestTestFakeServiceStatusParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestFakeServiceStatusMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Email Consent Id
 */
export const getRequestTestEmailConsentId = (
    params: GetRequestTestEmailConsentIdParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<EmailConsentIDDTO>(
        { url: `/test/email_consent_id`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestTestEmailConsentIdQueryKey = (
    params?: GetRequestTestEmailConsentIdParams,
) => {
    return [`/test/email_consent_id`, ...(params ? [params] : [])] as const
}

export const getGetRequestTestEmailConsentIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestEmailConsentIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestTestEmailConsentIdQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestTestEmailConsentId>>
    > = ({ signal }) =>
        getRequestTestEmailConsentId(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestTestEmailConsentIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestTestEmailConsentId>>
>
export type GetRequestTestEmailConsentIdQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestTestEmailConsentId<
    TData = Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestEmailConsentIdParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestTestEmailConsentId>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestTestEmailConsentId<
    TData = Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestEmailConsentIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestTestEmailConsentId>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestTestEmailConsentId<
    TData = Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestEmailConsentIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Email Consent Id
 */

export function useGetRequestTestEmailConsentId<
    TData = Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTestEmailConsentIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestTestEmailConsentId>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestTestEmailConsentIdQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * @summary Poke Longpoller
 */
export const postRequestTestPokeLongpoller = (
    params: PostRequestTestPokeLongpollerParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        { url: `/test/poke_longpoller`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestTestPokeLongpollerMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestTestPokeLongpoller>>,
        TError,
        { params: PostRequestTestPokeLongpollerParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestTestPokeLongpoller>>,
    TError,
    { params: PostRequestTestPokeLongpollerParams },
    TContext
> => {
    const mutationKey = ['postRequestTestPokeLongpoller']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestTestPokeLongpoller>>,
        { params: PostRequestTestPokeLongpollerParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestTestPokeLongpoller(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestTestPokeLongpollerMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestTestPokeLongpoller>>
>

export type PostRequestTestPokeLongpollerMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Poke Longpoller
 */
export const usePostRequestTestPokeLongpoller = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestTestPokeLongpoller>>,
            TError,
            { params: PostRequestTestPokeLongpollerParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestTestPokeLongpoller>>,
    TError,
    { params: PostRequestTestPokeLongpollerParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestTestPokeLongpollerMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
